import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FloCssClassSanitizePipeModule } from 'src/app/libs/_pipes/css-class-sanitize/css-class-sanitize.pipe.module'
import { RouterModule } from '@angular/router'
import { LinkModule } from '../link/link.module'
import { TabsComponent } from './tabs.component'

@NgModule({
  imports: [CommonModule, RouterModule, FloCssClassSanitizePipeModule, LinkModule],
  exports: [TabsComponent],
  declarations: [TabsComponent]
})
export class TabsModule {}
